import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { format } from 'date-fns';

import { Alert, Button, Loader, Modal, Table } from '@itds/elements';

import EditTableRateDrawer from './Edit';

import Api from '@carrier/utils/Api';

const List = () => {
  const params = useParams();

  const [table_rates, setTableRates] = useState([]);
  const [table_rate, setTableRate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error_message, setErrorMessage] = useState(null);
  const [success_message, setSuccessMessage] = useState(null);
  const [modal, setModal] = useState(false);
  const [deleteTable, setDeleteTable] = useState(null);

  useEffect(() => {
    loadTableRates();
  }, []);

  const loadTableRates = action => {
    setLoading(true);

    setTimeout(() => {
      setSuccessMessage(null);
      setErrorMessage(null);
    }, 2000);

    Api.loadTableRates({ carrier_id: params.id, data_version_id: params.version_id })
      .then(({ data }) => {
        setTableRates(data);
        setLoading(false);
        if (action === 'add') {
          setSuccessMessage('Table Rate Successfully Added');
        } else if (action === 'delete') {
          setSuccessMessage('Table Rate Successfully Deleted');
        }
      })
      .catch(() => {
        if (action === 'add') {
          setErrorMessage('Unable to add Table Rates at this time');
        } else if (action === 'delete') {
          setErrorMessage('Unable to delete Table Rates at this time');
        }
      });
  };

  const handleSave = () => {
    setTableRate(null);
    loadTableRates('add');
  };

  const handleDelete = (tableRate, e) => {
    e.stopPropagation();

    window.scrollTo(0, 0);
    setModal(true);
    setDeleteTable(tableRate);
  };

  const confirmDelete = () => {
    window.scrollTo(0, 0);

    Api.deleteTableRate(deleteTable.id)
      .then(() => {
        loadTableRates('delete');
        setModal(null);
        setDeleteTable(null);
      })
      .catch(() => {
        setModal(null);
        setDeleteTable(null);
      });
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      <EditTableRateDrawer
        onClose={setTableRate.bind(null, null)}
        onSave={handleSave}
        show={!!table_rate}
        tableRate={table_rate}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button
          onClick={setTableRate.bind(null, {
            carrier_id: params.id,
            data_version_id: params.version_id
          })}
        >
          Add Table Rate
        </Button>
      </div>

      <Table
        columns={[
          {
            id: 'name',
            label: 'Name'
          },
          {
            id: 'id',
            label: 'ID'
          },
          {
            id: 'updated_at',
            label: 'Last Updated',
            render: table_rate => format(new Date(table_rate.updated_at), 'MM/dd/yyyy')
          },
          {
            id: 'actions',
            render: table_rate => {
              return (
                <div>
                  <Button
                    color='RED'
                    inline={true}
                    onClick={handleDelete.bind(null, table_rate)}
                    small={true}
                  >
                    Delete
                  </Button>
                </div>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={table_rates}
        onRowClick={setTableRate}
      />

      {modal ? (
        <Modal
          buttons={[
            {
              color: 'RED',
              children: 'Confirm Delete',
              onClick: confirmDelete,
              style: { marginLeft: 'auto' }
            }
          ]}
          contained={true}
          onClose={() => {
            setModal(null);
          }}
          title={`Delete "${deleteTable.name}"`}
        >
          <div style={{ padding: 40, fontSize: 16, textAlign: 'center', lineHeight: '1.5em' }}>
            Are you sure you want to delete "{deleteTable.name}"?
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default List;
